"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import CourseCard from "../../components/cards/course-card";
import ComingSoonModal from "../../components/modals/coming-soon-modal";
import ProgramBuildingModal from "../../components/forms/program-building-modal";
import { openFreeTraining } from "../../utils/lms-navigation";

const PROFESSIONAL_CONTENT_TYPES = {
	COMPETENCY_FRAMEWORK: "COMPETENCY_FRAMEWORK",
	CERTIFICATE: "CERTIFICATE",
	PROGRAM_BUILDING: "PROGRAM_BUILDING",
	FREE_TRAINING: "FREE_TRAINING",
} as const;

type ProfessionalContentType = keyof typeof PROFESSIONAL_CONTENT_TYPES;

const ProfessionalContentSection: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const [programBuildingModalOpen, setProgramBuildingModalOpen] =
		useState(false);
	const router = useRouter();

	const contentActions: Record<ProfessionalContentType, () => void> = {
		[PROFESSIONAL_CONTENT_TYPES.COMPETENCY_FRAMEWORK]: () =>
			router.push("/competency"),
		[PROFESSIONAL_CONTENT_TYPES.CERTIFICATE]: () => setModalOpen(true),
		[PROFESSIONAL_CONTENT_TYPES.PROGRAM_BUILDING]: () =>
			setProgramBuildingModalOpen(true),
		[PROFESSIONAL_CONTENT_TYPES.FREE_TRAINING]: openFreeTraining,
	};

	const handleCardClick = (contentType: ProfessionalContentType) => {
		const action = contentActions[contentType];
		if (action) {
			action();
		}
	};

	const handleCloseModal = () => {
		setModalOpen(false);
	};

	const content = [
		{
			type: PROFESSIONAL_CONTENT_TYPES.COMPETENCY_FRAMEWORK,
			title: "Khung năng lực & Kiểm tra",
			imageSrc: "/assets/images/skill-development.svg",
			imageAlt: "Khung năng lực & Kiểm tra",
		},
		{
			type: PROFESSIONAL_CONTENT_TYPES.CERTIFICATE,
			title: "Chứng chỉ",
			imageSrc: "/assets/images/certificate.svg",
			imageAlt: "Chứng chỉ",
		},
		{
			type: PROFESSIONAL_CONTENT_TYPES.PROGRAM_BUILDING,
			title: "Tư vấn Xây dựng chương trình",
			imageSrc: "/assets/images/advisor.svg",
			imageAlt: "Tư vấn xây dựng chương trình",
		},
		{
			type: PROFESSIONAL_CONTENT_TYPES.FREE_TRAINING,
			title: "Free training cho L&D",
			imageSrc: "/assets/images/training.svg",
			imageAlt: "Free training cho L&D",
		},
	];

	return (
		<>
			<section className="bg-white rounded-2xl p-6 mb-12">
				<h2 className="text-2xl font-semibold text-gray-800 mb-6">
					Nội dung chuyên môn và tư vấn
				</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
					{content.map((item) => (
						<CourseCard
							key={item.type}
							title={item.title}
							imageSrc={item.imageSrc}
							imageAlt={item.imageAlt}
							onClick={() => handleCardClick(item.type)}
						/>
					))}
				</div>
			</section>
			{/* Modals */}
			<ComingSoonModal open={modalOpen} onClose={handleCloseModal} />
			<ProgramBuildingModal
				open={programBuildingModalOpen}
				onClose={() => setProgramBuildingModalOpen(false)}
			/>
		</>
	);
};

export default ProfessionalContentSection;
